import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Company } from 'app/modules/domain/models/company';
import { User } from 'app/modules/domain/models/user';
import { Quota } from 'app/modules/domain/models/quota';
import { EditCompanyQuotaComponent } from '../my-organisation/components/edit-company/edit-company-quota.component';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'app-organisations',
  templateUrl: './organisations.component.html',
  styleUrls: ['./organisations.component.scss']
})
export class OrganisationsComponent implements OnInit {
  public companies: Company[] = [];
  public selectedCompany: Company;
  public users: User[] = [];
  public errorString: string;

  public allocatedQuota: number;
  public companyQuota: number;
  public companyApiKey: string;

  constructor(private adminService: AdminService,
              public dialog: MdDialog) { }

  ngOnInit() {
    this.getCompanies();
  }

  private getCompanies(): void {
    this.adminService.getCompanies()
      .subscribe((companies: Company[]) => {
        this.companies = companies;
      });
  }

  public onCompanySelect(company: Company) {
    this.dismissError();
    this.users = [];
    this.selectedCompany = company;
    this.getUsers();
  }

  public onUpdateCompanies() {
    this.getCompanies();
    this.getUsers();
  }

  public onUpdateUsers() {
    this.getUsers();
  }

  private getUsers(): void {
    this.adminService.getUsersForCompany(this.selectedCompany.id)
      .subscribe((users: User[]) => {
        this.enrichUsers(users);
      }, (err) => {
        if (Array.isArray(err.error)) {
          const errorKey = Object.keys(err.error)[0];
          this.setError(errorKey ? `UPDATE_COMPANY.${errorKey}` : 'UNKNOWN_ERROR');
        } else {
          this.setError('UNKNOWN_ERROR');
        }

        this.allocatedQuota = 0;
        this.companyQuota = 0;
        this.companyApiKey = undefined;
        this.users = [];
      });
  }

  private enrichUsers(users: User[]): void {
    this.adminService.getQuotaForCompanyUsers(this.selectedCompany.id).subscribe((quotas: Quota[]) => {
      const companyQuota = quotas.find(q => q.userId === q.companyId);

      if (companyQuota && companyQuota.limit && companyQuota.limit >= 0) {
        this.allocatedQuota = quotas.filter(q => q.userId !== q.companyId).reduce((prev, curr) => prev + curr.limit, 0);
        this.companyQuota = companyQuota.limit;
        this.companyApiKey = undefined;
      } else if (companyQuota && companyQuota.apiKey) {
        this.companyApiKey = companyQuota.apiKey;
        this.allocatedQuota = undefined;
        this.companyQuota = undefined;
      } else {
        this.allocatedQuota = 0;
        this.companyQuota = 0;
        this.companyApiKey = undefined;
      }

      if (this.selectedCompany) {
        this.selectedCompany = this.companies.find(c => c.id === this.selectedCompany.id);
        (this.selectedCompany as any).limit = companyQuota ? companyQuota.limit : 0;
      }

      this.users = users.map(u => {
        const userInfo = quotas.find(q => q.userId === u.id);

        return {
          ...u,
          limit: userInfo && userInfo.limit
        };
      });
    });
  }

  public openQuotaDialog() {
    const dialogRef = this.dialog.open(EditCompanyQuotaComponent, {
      width: '450px',
      data: { quota: this.companyQuota, apiKey: this.companyApiKey }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.doUpdateQuota(result);
      }
    });
  }

  private doUpdateQuota(newQuota: { quota?: number; apiKey?: string }): void {
    this.adminService.setQuotaForCompany(this.selectedCompany.id, newQuota)
        .subscribe((success) => {
          if (success) {
            if (newQuota.quota) {
              this.companyQuota = newQuota.quota;
              this.companyApiKey = undefined;
            } else {
              this.companyApiKey = newQuota.apiKey;
              this.allocatedQuota = undefined;
              this.companyQuota = undefined;
            }
          }
        }, (err) => {
          const errorKey = Object.keys(err.error)[0];
          this.setError(errorKey ? `UPDATE_COMPANY.${errorKey}` : 'UNKNOWN_ERROR');
        });
  }

  public setError(errorString: string): void {
    this.errorString = errorString;
    setTimeout(function () { this.dismissError(); }.bind(this), 7000);
  }

  public dismissError(): void {
    this.errorString = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/organisations/organisations.component.ts